import { Box } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

export const QEStrategydataFlowContext = createContext(null);
export const QEStrategyLoaderStateContext = createContext(null);

const QEStrategyMainPage = () => {
  const location = useLocation();

  const [businessContextAndRiskLandscape, setBusinessContextAndRiskLandscape] =
    useState({});
  const [
    applicationArchitectureAndDataIntegration,
    setApplicationArchitectureAndDataIntegration,
  ] = useState({});
  const [
    devopsTestAutomationAndDeveloperExperience,
    setDevopsTestAutomationAndDeveloperExperience,
  ] = useState({});
  const [aiMLLLMConsideration, setAiMLLLMConsideration] = useState({});
  const [
    observabilityResilienceSecurityAndScalability,
    setObservabilityResilienceSecurityAndScalability,
  ] = useState({});
  const [
    qualityCultureGovernanceAndTestDebt,
    setQualityCultureGovernanceAndTestDebt,
  ] = useState({});
  const [
    dataCentricAndCapabilityAlignedQE,
    setDataCentricAndCapabilityAlignedQE,
  ] = useState({});

  //Comes from file uploads
  const [dataFromFileUploads, setDataFromFileUploads] = useState([]);
  const [structuredCSVContext, setStructuredCSVContext] = useState(null);

  useEffect(() => {
    setDataFromFileUploads(location.state?.outputData);
  }, [location.state]);

  return (
    <Box>
      <QEStrategydataFlowContext.Provider
        value={{
          businessContextAndRiskLandscape,
          setBusinessContextAndRiskLandscape,
          applicationArchitectureAndDataIntegration,
          setApplicationArchitectureAndDataIntegration,
          devopsTestAutomationAndDeveloperExperience,
          setDevopsTestAutomationAndDeveloperExperience,
          aiMLLLMConsideration,
          setAiMLLLMConsideration,
          observabilityResilienceSecurityAndScalability,
          setObservabilityResilienceSecurityAndScalability,
          qualityCultureGovernanceAndTestDebt,
          setQualityCultureGovernanceAndTestDebt,
          dataCentricAndCapabilityAlignedQE,
          setDataCentricAndCapabilityAlignedQE,
          structuredCSVContext,
          setStructuredCSVContext,
          dataFromFileUploads,
          setDataFromFileUploads,
        }}
      >
        <Box sx={{ width: "100%", minWidth: 0 }}>
          <Outlet />
        </Box>
      </QEStrategydataFlowContext.Provider>
    </Box>
  );
};
export default QEStrategyMainPage;
